module.exports = __webpack_public_path__ + "img/ic_plus.55afc0a1.svg";